'use client';

import { usePageEvent } from '@/analytics/usePageEvent';
import classNames from 'classnames';
import { PropsWithChildren, useEffect } from 'react';
import styles from './page-container.module.scss';

export type PageContainerProps = {
  withoutBorder?: boolean;
  pageName: string;
  eventExtraData?: Record<string, unknown>;
  pageTitle?: string;
  routeName?: string;
};

export const PageContainer = ({
  children,
  withoutBorder,
  pageName,
  eventExtraData,
  pageTitle,
}: PropsWithChildren<PageContainerProps>) => {
  usePageEvent(pageName, eventExtraData);

  useEffect(() => {
    document.body.focus();
  }, []);

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
    }
  }, [pageTitle]);

  return (
    <div className={styles.wrapper}>
      <main
        className={classNames(
          styles.container,
          withoutBorder && styles.noBorder,
        )}
        aria-live="polite"
      >
        {children}
      </main>
    </div>
  );
};
